<template>
    <Dropdown
        v-show="showDepartmentDropdown"
        @close-dropdown="close"
        :is-open=showDepartmentDropdown
    >
        <slot />
    </Dropdown>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Dropdown from './Dropdown.vue';

export default {
    components: {
        Dropdown,
    },
    methods: {
        ...mapActions(['toggleDepartmentDropdown']),
        close() {
            if (this.showDepartmentDropdown) {
                this.toggleDepartmentDropdown();
            }
        },
    },
    computed: {
        ...mapState(['showDepartmentDropdown']),
    },
};
</script>
